import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
  Chip,
  Skeleton,
} from '@mui/material';
import { format } from 'date-fns';

function TripResult({ tripData, loading }) {
  const { dates, route, weather, flights, hotel } = tripData;

  const LoadingText = ({ children }) => {
    return loading ? (
      <Skeleton animation="wave" height={20} width="80%" />
    ) : (
      <Typography variant="body1">{children}</Typography>
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Your Trip
      </Typography>

      {/* Dates */}
      <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
        <Chip 
          label={format(new Date(dates.start), 'dd MMM yy')}
          color="primary"
          variant="outlined"
        />
        <Chip 
          label={format(new Date(dates.end), 'dd MMM yy')}
          color="primary"
          variant="outlined"
        />
      </Stack>

      {/* Route */}
      <Paper elevation={0} sx={{ p: 2, mb: 2, bgcolor: 'secondary.light' }}>
        <Typography variant="subtitle1">
          {route}
        </Typography>
      </Paper>

      {/* Weather */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Weather
        </Typography>
        <LoadingText>{weather}</LoadingText>
      </Box>

      {/* Flights */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Flights
        </Typography>
        <LoadingText>{flights}</LoadingText>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          Book
        </Button>
      </Box>

      {/* Hotel */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Hotel
        </Typography>
        <LoadingText>{hotel}</LoadingText>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          Book
        </Button>
      </Box>
    </Box>
  );
}

export default TripResult;
